import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { UploadedFile, FileUploadContainer, FileUpload } from './css';
import PlusBlack from '../../../assets/icons/PlusBlack.svg';
import RemoveBlack from '../../../assets/icons/RemoveBlack.svg';
import CheckmarkGreen from '../../../assets/icons/CheckmarkGreen.svg';
import { P } from '../../../theme/typography';
import { fileTypes } from '../../../utils/uploadedFiles';
import AlertModal from '../Modal/AlertModal';
import { ActionButton } from '../Modal/css';
import { runningOnBrowser } from '../../../utils/func';

const MB_MULTIPLIER = 1024 * 1024;
const MAX_FILE_SIZE = 4;
const TotalFileSize = [];
const ALLOWED_FILE_TYPES = /\.(pdf|tif|tiff)$/i;

export default class FieldFileInput extends PureComponent {
  constructor(props) {
    super(props);
    this.uploadField = React.createRef();
    this.state = {
      file: '',
      warning: '',
    };
  }

  getBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => cb(reader.result);
  };

  onFileChange = (e) => {
    const { input: { onChange }, onFileError } = this.props;
    const { name } = e.target.files[0];
    const file = e.target.files[0];

    if (onFileError && !ALLOWED_FILE_TYPES.test(name)) {
      onFileError();
      e.target.value = '';
      return;
    }

    TotalFileSize.push(file.size);
    const CalculatedFileSize = TotalFileSize.reduce((prevFileSize, currentFileSize) => prevFileSize + currentFileSize, 0);
    if (CalculatedFileSize <= MAX_FILE_SIZE * MB_MULTIPLIER) {
      this.getBase64(file, async (result) => {
        await this.setState({ file: result.split('base64,')[1] });
        onChange({ name, file: this.state.file });
      });
      e.target.value = '';
    } else {
      TotalFileSize.pop();
      if (onFileError) {
        onFileError();
      } else if (runningOnBrowser()) {
        if (window.location.href.includes('dedicated')) {
          this.setState({ warning: t('DedicatedMaxFileSizeReached', { size: `${MAX_FILE_SIZE}` }) });
        } else {
          this.setState({ warning: t('MaxFileSizeReached', { size: `${MAX_FILE_SIZE}` }) });
        }
      }
    }
  };

  triggerClick = () => {
    this.uploadField.current.click();
  };

  removeFile = (e) => {
    const { input: { onChange } } = this.props;
    TotalFileSize.pop(e.size);
    onChange('');
  };

  closeWarningModal = () => this.setState({ warning: '' });

  render() {
    const { warning } = this.state;
    const {
      label, attachButton, input: { value, name }, className,
    } = this.props;

    return (
      <FileUploadContainer className={className}>
        {label && (
        <P className="label">{label}</P>
        )}
        <FileUpload>
          {
                        value
                          ? (
                            <>
                              <UploadedFile>
                                <span><img src={CheckmarkGreen} alt={t('FileSelected')} /></span>
                                {value.name}
                              </UploadedFile>
                              {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                              <label
                                htmlFor={name}
                                onClick={this.removeFile}
                                onKeyPress={(e) => e.key === 'Enter' && this.removeFile(e)}
                                aria-label={t('Remove')}
                                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                                tabIndex="0"
                              >
                                <img src={RemoveBlack} alt={t('Remove')} />
                                <input
                                  ref={this.uploadField}
                                  type="file"
                                  onChange={this.onFileChange}
                                  hidden
                                  accept={fileTypes}
                                  id={name}
                                />
                              </label>
                            </>
                          )
                          : (
                            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                            <label
                              htmlFor={name}
                              onClick={() => this.triggerClick}
                              onKeyPress={(e) => e.key === 'Enter' && this.triggerClick(e)}
                              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                              tabIndex="0"
                            >
                              <input
                                ref={this.uploadField}
                                type="file"
                                onChange={this.onFileChange}
                                hidden
                                accept={fileTypes}
                                id={name}
                              />
                              <span><img src={PlusBlack} alt="Upload part file" /></span>
                              {value ? value.name : attachButton}
                            </label>
                          )
                    }

        </FileUpload>
        {
                    warning && (
                    <AlertModal
                      isOpen={!!warning}
                      onClose={this.closeWarningModal}
                      header={() => t('Warning')}
                        // eslint-disable-next-line react/no-unstable-nested-components
                      content={() => (
                        <div style={{
                          textAlign: 'left', lineHeight: '1.4em', marginBottom: '12px', letterSpacing: '0.005em',
                        }}
                        >
                          {warning}
                        </div>
                      )}
                        // eslint-disable-next-line react/no-unstable-nested-components
                      actions={() => <ActionButton className="active" iconRightArrow onClick={this.closeWarningModal}>{t('Ok')}</ActionButton>}
                      maximizeZIndex
                    />
                    )
                }
      </FileUploadContainer>
    );
  }
}

FieldFileInput.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    name: PropTypes.string,
  }),
  label: PropTypes.string,
  attachButton: PropTypes.string,
  className: PropTypes.string,
  onFileError: PropTypes.func,
};
